// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar-module__avatar__Fk1XJ","regular":"Avatar-module__regular__2wXFZ","bright":"Avatar-module__bright__s7hft"};